module.exports = __webpack_public_path__ + "static/media/add_file.3638ea3e.svg";